import { Result } from '@/core/models/Result';
import LivestreamProductEntity from '../entities/LivestreamProductEntity';

export default class GetLivestreamProductResult extends Result<LivestreamProductEntity> {}
